<template>
    <div class="relative flex min-h-9 gap-0 rounded-lg bg-[#728AC3]">
        <div
            :class="{ 'transition-all duration-300 ease-in-out': hasInteracted }"
            :style="{
                left: `${activePosition.left}px`,
                width: `${activePosition.width}px`,
            }"
            class="absolute inset-y-0 rounded-lg border border-white bg-primary"
        />
        <button
            v-for="(option, index) in options"
            :key="index"
            ref="buttonRefs"
            :class="[modelValue === option.value ? 'opacity-100' : 'opacity-40']"
            class="relative z-10 grow px-4 py-2 text-sm !leading-[1.1] font-medium text-white transition-opacity duration-300 focus-visible:outline-none"
            type="button"
            @click="selectOption(option.value, index)"
        >
            {{ option.label }}
        </button>
    </div>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const buttonRefs = ref([]);
const activePosition = ref({ left: 0, width: 0 });
const hasInteracted = ref(false);

const activeIndex = computed(() => {
    const idx = props.options.findIndex((option) => option.value === props.modelValue);
    return Math.max(idx, 0);
});

const updateActivePosition = () => {
    nextTick(() => {
        const activeButton = buttonRefs.value[activeIndex.value];
        if (activeButton) {
            activePosition.value = {
                left: activeButton.offsetLeft,
                width: activeButton.offsetWidth,
            };
        }
    });
};

const selectOption = (value, index) => {
    if (value !== props.modelValue) {
        hasInteracted.value = true;
        emit('update:modelValue', value);
    }
};

watch(
    () => [props.modelValue, props.options],
    () => {
        updateActivePosition();
    },
    { deep: true },
);

onMounted(() => {
    updateActivePosition();
    window.addEventListener('resize', updateActivePosition);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateActivePosition);
});
</script>
